import axios from 'axios';

async function getAddressSugestions(query) {
  const { data } = await axios.get(
    `https://api.maptiler.com/geocoding/${query}.json`
    + '?language=nl,fr&country=be&types=address'
     + `&key=${import.meta.env.VITE_MAPTILER_API_KEY}`,
  );

  if (data?.features) {
    return data?.features.map(feature => ({
      label: feature?.place_name,
      id: feature?.id,
      data: feature,
    }));
  }
  
  return [];
}

export {
  getAddressSugestions,
};